module.exports = __webpack_public_path__ + "static/media/ack-malyalam.0db27cad.jpeg";